define('models/publisher',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.Publisher = T1Model.extend({
    url: "publishers/",
    fixture: "-publishers"
  });
  return T1.Models.Publisher;
});
